function toggleCart() {
  document.querySelector('#cart-drawer').classList.toggle('is-open')
  document.querySelector('#cart-drawer').classList.toggle('is-drawer-open')

  document.querySelector('html').style.overflowY =
    document.querySelector('#cart-drawer').classList.contains('is-open') ? 'hidden' : 'unset'
}

let upgradeFromVariantId = ''
let upgradeBlock = null

function bodyOverflow() {
  setTimeout(() => {
    document.body.style.overflow = 'hidden'
  }, 500)
  window.removeEventListener('transitionend', bodyOverflow)
}


function fetchCart() {
  fetch('/cart?section_id=api-cart-drawer')
    .then((response) => response.text())
    .then((response) => {
      document.querySelector('#cart-drawer').classList.remove('is-loading')

      document.querySelector('#cart-drawer').querySelector('.drawer__inner').innerHTML =
        new DOMParser().parseFromString(response, 'text/html').querySelector('.drawer__inner').innerHTML

      setTimeout(() => {
        document.querySelector('[data-cart-toggle]').click()
      })
    })
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll(['[data-cart-toggle]', '#cart-drawer .drawer__underlay']).forEach(item => item.addEventListener('click', (event) => {
    event.preventDefault()
    event.stopPropagation()
    event.stopImmediatePropagation()
    toggleCart()
  }))

})

if (!customElements.get('continue-shopping')) {
  customElements.define('continue-shopping', class ContinueShoppingItem extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('click', (event) => {
        toggleCart()
      })
    }
  })
}

if (!customElements.get('cart-item')) {
  customElements.define('cart-item', class CartItem extends HTMLElement {
    constructor() {
      super();

      this.querySelector('.cart_item_remove').addEventListener('click', (event) => {
        event.target.classList.add('free-gift-loading')

        CartJS.removeItem(event.target.getAttribute('data-line'))
      })

      if (this.querySelector('.cart__quantity-minus')) {
        this.querySelector('.cart__quantity-field').addEventListener('change', () => {
          this.updateQuantity()
        })
        this.querySelector('.cart__quantity-minus').addEventListener('click', () => {
          this.querySelector('input').stepDown()
          this.updateQuantity()
        })
        this.querySelector('.cart__quantity-plus').addEventListener('click', () => {
          this.querySelector('input').stepUp()
          this.updateQuantity()
        })
      }
    }

    timeout = null

    updateQuantity() {
      if (this.timeout) {
        return
      }

      this.timeout = setTimeout(() => {
        this.querySelector('.cart_item_remove').classList.add('free-gift-loading')
        CartJS.updateItem(this.querySelector('.cart_item_remove').getAttribute('data-line'), this.querySelector('input').value)
        this.timeout = null
      }, 300)
    }
  })
}

if (!customElements.get('quick-add')) {
  customElements.define('quick-add', class QuickAdd extends HTMLElement {
    constructor() {
      super();

      const addToCartButton = this.querySelector('[data-add-to-cart]');
      if (!addToCartButton) return;

      addToCartButton.addEventListener('click', event => {
        event.preventDefault();
        event.stopPropagation();

        const variantId = this.querySelector('input[name="id"]').value;
        const qty = this.querySelector('input[name="quantity"]')?.value ?? '1';
        const props = {};

        // Handle both button and other elements with `data-add-to-cart`
        const upsellProductId = Number(
          addToCartButton.getAttribute('data-upsell-id')
        );

        this.querySelectorAll('input').forEach(item => {
          if (item.getAttribute('name') === 'id') {
            return;
          }

          props[item.getAttribute('name')] = item.value; // Fixed props value assignment
        });

        addToCartButton.classList.add('free-gift-loading');
        $(document).on('cart.requestComplete', this.updateBtn.bind(this));
        CartJS.addItem(variantId, qty);
      });
    }

    updateBtn() {
      const btn = this.querySelector('[data-add-to-cart]');
      if (!btn) return;

      btn.classList.remove('free-gift-loading');
      $(document).off('cart.requestComplete', this.updateBtn.bind(this));
    }

    resetButton() {
      const btn = this.querySelector('[data-add-to-cart]');
      if (!btn) return;

      btn.classList.remove('is-loading');
      btn.classList.remove('is-added');
      btn.removeEventListener('transitionend', this.resetButton);
    }
  });
}



if (!customElements.get('cart-header')) {
  customElements.define('cart-header', class CartHeader extends HTMLElement {
    constructor() {
      super();

      this.querySelector('.drawer__close').addEventListener('click', event => {
        toggleCart()
      })
    }
  })
}

if (!customElements.get('cart-count')) {
  customElements.define('cart-count', class CartHeader extends HTMLElement {
    constructor() {
      super();

      this.cartJson = JSON.parse(document.querySelector('#cart-json').innerHTML)

      let currentCount = Number(this.innerHTML)

      const protectionId = Number(this.getAttribute('data-order-protection-id'))

      for (const item of this.cartJson.items) {
        if (item.product_id === protectionId) {
          currentCount--
        }
      }

      this.updateCount(currentCount)
    }

    cartJson = null

    updateCount(count) {
      if (count === 0) {
        this.classList.add('hidden')
        return
      }

      this.innerHTML = count
      this.classList.remove('hidden')
    }
  })
}
